import { i18n, loadLanguageAsync } from '@/i18n'

export default {
  computed: {
    currentLang () {
      return this.lang[i18n.locale]
    }
  },
  created () {
    loadLanguageAsync()
  },
  methods: {
    sendEmail (email) {
      this.resetResponse()
      return this.$api.resetPassword(email, this.currentLang)
        .then(() => {
          this.$store.commit('RESET_PWD_DONE', true)
          this.$router.push('/login')
        })
        .catch((error) => {
          this.response = error.data
          this.loading = false
        })
    },
    resetResponse () {
      this.response = ''
    },
    validateForm () {
      return this.$validator.validateAll().then((valid) => {
        if (valid) {
          const { email } = this
          this.loading = true
          return this.sendEmail(email)
        }
      })
    }
  },
  name: 'ResetPassword',
  data (router) {
    return {
      email: '',
      lang: {
        en: 'en-US',
        zh: 'zh-TW'
      },
      loading: false,
      response: '',
      section: 'Reset Password'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ResetPassword/ResetPassword.js